(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}(function () { 'use strict';

    function initAnimations() {
        setTimeout(() => {

            const root_classes = ['body:is(.page, .single-demo) .entry-content > *'];
            const child_classes = [];

            root_classes.forEach((rootClassName) => {
                document.querySelectorAll(rootClassName).forEach(el => {

                    if (el.classList.contains('animation--none')) {
                        return;
                    }

                    el.classList.add('root-animation');
                    child_classes.forEach((i) => {
                        el.querySelectorAll(i).forEach((f) => f.classList.add('inner-animation'));
                    });
                });
            });

            document.querySelectorAll('.root-animation')
                .forEach((root) => {
                    basicScroll.create({
                        elem: root,
                        from: 'top-bottom',
                        to: 'top-middle',
                        direct: true,
                        timing: 'circInOut',
                        props: {
                            '--root--fade': {
                                from: 0,
                                to: 1
                            },
                            '--root--scroll--top': {
                                from: 3,
                                to: 0
                            },
                        }
                    }).start();

                    basicScroll.create({
                        elem: root,
                        from: 'middle-top',
                        to: 'bottom-top',
                        direct: true,
                        timing: 'circInOut',
                        props: {
                            '--root--scroll': {
                                from: 0,
                                to: -3
                            },
                        }
                    }).start();

                    root.querySelectorAll('.inner-animation').forEach((child, index) => {
                        basicScroll.create({
                            elem: child,
                            from: 'top-middle',
                            to: 'middle-top',
                            direct: true,
                            timing: 'circInOut',
                            props: {
                                // '--child--fade': {
                                //     from: 0,
                                //     to: 1
                                // },
                                '--child--scroll-top': {
                                    from: 0,
                                    // to: (index + 1) * -1.5 + index * .25
                                    to: -1.5
                                },
                            }
                        }).start();
                    });
                });

        }, 1500);

        const header = document.querySelector('.header');
        if (header) {
            header.classList.add('ready');
        }

        const body = document.querySelector('body');
        if (body) {
            body.classList.add('ready');
        }

    }

    function initHubspot($) {
        $.fn.notifyHubspot = function () {
            function doEvent(obj, name) {
                try {
                    const event = new Event(name, {target: obj, bubbles: true});
                    return obj ? obj.dispatchEvent(event) : false;
                } catch (e) {
                    const event = document.createEvent('Event');
                    event.initEvent(name, true, true);
                    obj.dispatchEvent(event);
                }
            }

            $(this).each(function () {
                doEvent(this, 'change');
                doEvent(this, 'input');
                doEvent(this, 'blur');
            });

            $(this).focus();
            $(this).blur();

            return $(this);
        };
    }

    function prepopulateURLField($) {
        let title = document.title;
        const yoastTag = document.querySelector('.yoast-seo-meta-tag[property="og:title"]');
        if (yoastTag) {
            title = yoastTag.content;
        }

        window.addEventListener('message', (event) => {
            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
                const forms = document.querySelectorAll('.hs-form-' + event.data.id);
                forms.forEach(function (form) {
                    updateTitleField(form);
                });
            }
        });

        function updateTitleField(form) {
            const conversionURLField = form.querySelector("input[name='conversion_page_url']");
            if (!conversionURLField) {
                return;
            }

            $(conversionURLField).val(title).notifyHubspot();
        }
    }

    function pageScroll($) {
        const docElem = $(document.documentElement);

        const data = {
            pageHeight: docElem.height(),
            scrollTriggerPosition: function () {
                return this.pageHeight * 0.35; // 35% of the page height
            },
        };

        $(window).on('scroll', () => {
            const currentScrollPosition = $(window).scrollTop();
            $('body').toggleClass('page-scrolled', currentScrollPosition > data.scrollTriggerPosition());
        });

        $(window).on('resize', () => {
            data.pageHeight = docElem.height();
        });
    }

    // import {initEmailVerification} from "./email-verification.js";

    /*
     * Global Blocks init function.
     */

    // TODO: find a way to move this initBlock function to the plugin. (make sure Header Platform dropdown works).
    function initBlock(blockName = '', selector = '', cb) {

        if (window.acf) {
            window.acf.addAction('render_block_preview', function (el, block) {
                const acfBlockName = blockName.split(/@|\//).filter(e => !!e).join('--');
                if (block.name === 'acf/' + acfBlockName) {
                    cb(el[0]);
                }
            });
        } else {
            document.querySelectorAll(selector).forEach((el) => cb(el));
        }

    }

    window.initBlock = initBlock;

    /*
     * Custom
     */

    (function ($) {

        /**
         * Init
         */

        try {
            initAnimations();
            initHubspot($);
            prepopulateURLField($);
            pageScroll($);
            // initEmailVerification();
        } catch (err) {
            console.error(err);
        }

    })(window.jQuery);

}));
